import "bootstrap";
import $ from "jquery";

/* This file is for fixing bugs that are specific to bootstrap core and not being fixed by the maintainers despite PRs submitted */
/* Can be removed if and when we move to Bootstrap 4.x (still in alpha) */

/* Fixing tooltip & popover offset bug when horizontally scrolling in 3.3.x
   Issue: https://github.com/twbs/bootstrap/issues/15590
   Solution taken from: https://github.com/twbs/bootstrap/pull/15686/files */
$.fn.tooltip.Constructor.prototype.getPosition = function($element) {
  $element = $element || this.$element;

  var el     = $element[0];
  var isBody = el.tagName === 'BODY';

  var elRect    = el.getBoundingClientRect();
  if (elRect.width == null) {
    // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
    elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
  }
  var elOffset  = isBody ? { top: 0, left: 0 } : $element.offset();
  var scroll    = isBody ? { scroll: { top: document.documentElement.scrollTop || document.body.scrollTop, left: document.documentElement.scrollLeft || document.body.scrollLeft } }
    : { scroll: { top: $element.scrollTop(), left: $element.scrollLeft() } };
  var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;

  return $.extend({}, elRect, scroll, outerDims, elOffset);
};

$.fn.tooltip.Constructor.prototype.getViewportAdjustedDelta = function(placement, pos, actualWidth, actualHeight) {
  var delta = { top: 0, left: 0 };
  if (!this.$viewport) return delta;

  var viewportPadding = (this.options.viewport && this.options.viewport.padding) || 0;
  var viewportDimensions = this.getPosition(this.$viewport);

  if (/right|left/.test(placement)) {
    var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll.top;
    var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll.top + actualHeight;
    if (topEdgeOffset < viewportDimensions.top) { // top overflow
      delta.top = viewportDimensions.top - topEdgeOffset;
    } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
      delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
    }
  } else {
    var leftEdgeOffset  = pos.left - viewportPadding - viewportDimensions.scroll.left;
    var rightEdgeOffset = pos.left + viewportPadding - viewportDimensions.scroll.left + actualWidth;
    if (leftEdgeOffset < viewportDimensions.left) { // left overflow
      delta.left = viewportDimensions.left - leftEdgeOffset;
    } else if (rightEdgeOffset > viewportDimensions.width) { // right overflow
      delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
    }
  }

  return delta;
};

// Popover extended tooltip, but with a new object, so update its prototype too
$.fn.popover.Constructor.prototype.getPosition = $.fn.tooltip.Constructor.prototype.getPosition;
$.fn.popover.Constructor.prototype.getViewportAdjustedDelta = $.fn.tooltip.Constructor.prototype.getViewportAdjustedDelta;
